import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useQuotaWarnings } from "@/hooks/useApiUsage";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const SERVICE_LABELS: Record<string, string> = {
  "46elks": "SMS",
  resend: "Sähköposti",
};

export function QuotaWarningsAlert() {
  const warnings = useQuotaWarnings();

  if (!warnings || warnings.length === 0) {
    return null;
  }

  const hasCritical = warnings.some((w) => w.level === "critical");

  return (
    <Alert
      variant={hasCritical ? "destructive" : "default"}
      className={
        hasCritical
          ? "border-destructive/50 bg-destructive/10"
          : "border-orange-500/50 bg-orange-500/10"
      }
    >
      <AlertTriangle
        className={`h-4 w-4 ${hasCritical ? "text-destructive" : "text-orange-500"}`}
      />
      <AlertTitle>
        {hasCritical ? "API-kiintiö ylittynyt!" : "API-kiintiövaroitus"}
      </AlertTitle>
      <AlertDescription className="space-y-2">
        <ul className="list-disc list-inside space-y-1">
          {warnings.map((warning) => (
            <li key={warning.service}>
              <strong>{SERVICE_LABELS[warning.service] || warning.service}</strong>:{" "}
              {warning.used} / {warning.limit} ({warning.percentage}%)
              {warning.level === "critical" && (
                <span className="ml-1 text-destructive font-medium">
                  — raja saavutettu
                </span>
              )}
            </li>
          ))}
        </ul>
        <div className="pt-2">
          <Button asChild variant="outline" size="sm">
            <Link to="/api-usage">Näytä API-käyttö</Link>
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
